import { useState } from 'react';
import { Pencil } from 'lucide-react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import Input from '@/components/form/Input';
import SpinnerButton from '@/components/common/SpinnerButton';
import Error from '@/components/common/Error';

import { Button } from '@/components/ui/button';

import { useTenantSettings, usePutTenantSettings } from '@/data/tenantSetting';

const formSchema = z.object({
  primaryPhone: z.string().min(1),
  primaryEmail: z.string().email()
});

const Edit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const tenantSettings = useTenantSettings();
  const putTenantSettings = usePutTenantSettings();

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      primaryPhone: tenantSettings.data?.primaryPhone || '',
      primaryEmail: tenantSettings.data?.primaryEmail || ''
    }
  });

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      setApiError('');
      await putTenantSettings(values);
      await tenantSettings.mutate();
      setSubmitting(false);
      setIsEditing(false);
    } catch (err) {
      setApiError(err.message);
      setSubmitting(false);
    }
  };

  if (isEditing) {
    return (
      <>
        <h3 className="text-xl mb-4">Edit Contact Info</h3>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <div className="max-w-[50%]">
              <Input
                name="primaryPhone"
                label="Primary Phone"
                autoComplete="off"
              />
              <Input
                name="primaryEmail"
                label="Primary Email"
                autoComplete="off"
              />
            </div>

            {apiError && <Error error={apiError} />}

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
              <SpinnerButton loading={submitting}>Save Changes</SpinnerButton>
            </div>
          </form>
        </Form>
      </>
    );
  }

  return (
    <>
      <div className="flex gap-2 items-center mb-4 ">
        <h3 className="text-xl">Contact Info</h3>
        <Button variant="icon" onClick={() => setIsEditing(true)}>
          <Pencil size={20} />
        </Button>
      </div>
      <div className="mb-4">
        <h4>Primary Phone</h4>
        <span>{tenantSettings.data?.primaryPhone || 'none'}</span>
      </div>
      <div className="mb-4">
        <h4>Primary Email</h4>
        <span>{tenantSettings.data?.primaryEmail || 'none'}</span>
      </div>
    </>
  );
};

export default Edit;
